module.exports = __webpack_public_path__ + "static/media/MHRM09N1015.f518d23c.svg";